
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class VignetteLogo extends Vue {
  @Prop()
  private msg!: string;
}
